import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Acquisti from "./pages/Acquisti";
import Ritiri from "./pages/Ritiri";
import Accettazione from "./pages/Accettazione";
import Bolle from "./pages/Bolle";
import Posteggi from "./pages/Posteggi";
import Utenti from "./pages/Utenti";
import Fornitori from "./pages/Fornitori";
import Prodotti from "./pages/Prodotti";
import Statistiche from "./pages/Statistiche";
import Autisti from "./pages/Autisti";
import Documenti from "./pages/Documenti";
import Hd from "./pages/Hd";
import Personalizzazione from "./pages/Personalizzazione";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App dark">
      <SettingsProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-right" theme="dark" richColors />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Protected><Dashboard /></Protected>} />
              <Route path="/acquisti" element={<Protected><Acquisti /></Protected>} />
              <Route path="/ritiri" element={<Protected><Ritiri /></Protected>} />
              <Route path="/accettazione" element={<Protected><Accettazione /></Protected>} />
              <Route path="/bolle" element={<Protected><Bolle /></Protected>} />
              <Route path="/documenti" element={<Protected><Documenti /></Protected>} />
              <Route path="/fornitori" element={<Protected><Fornitori /></Protected>} />
              <Route path="/prodotti" element={<Protected><Prodotti /></Protected>} />
              <Route path="/posteggi" element={<Protected><Posteggi /></Protected>} />
              <Route path="/statistiche" element={<Protected><Statistiche /></Protected>} />
              <Route path="/autisti" element={<Protected><Autisti /></Protected>} />
              <Route path="/utenti" element={<Protected><Utenti /></Protected>} />
              <Route path="/hd" element={<Protected><Hd /></Protected>} />
              <Route path="/personalizza" element={<Protected><Personalizzazione /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
